import { useEffect, useState } from 'react';
import { getProductionCalendars } from 'services/api';
import type { ProductionCalendarTab } from './types';

interface UseProductionCalendarTabsServiceProps {
  onSelectTab: (tab: string) => void;
}

export const useProductionCalendarTabsService = ({
  onSelectTab,
}: UseProductionCalendarTabsServiceProps) => {
  const [loading, setLoading] = useState(false);
  const [tabs, setTabs] = useState<ProductionCalendarTab[]>([]);

  useEffect(() => {
    setLoading(true);
    getProductionCalendars()
      .then((res) => {
        const transformedTabs = res.map(({ calendarYear }) => ({
          key: calendarYear,
          name: calendarYear,
        }));
        setTabs(transformedTabs);
        onSelectTab(transformedTabs[0].key);
      })
      .finally(() => setLoading(false));
  }, [onSelectTab]);

  return { state: { loading, tabs } };
};
